export default __webpack_public_path__ + "static/media/x.fbed2134.svg";